export function getConsumerControlState(control_modes) {
    const { summer_mode, external_thermostat, external_thermostat_heat_request } = control_modes;
    if (summer_mode) {
        return { mode: 'summer', title: 'Режим лето' };
    }
    if (external_thermostat_heat_request) {
        return {
            mode: 'external-thermostat-heat-request',
            title: 'Управление с помощью внешнего термостата - запрос тепла',
        };
    }
    if (external_thermostat) {
        return {
            mode: 'external-thermostat',
            title: 'Управление с помощью внешнего термостата',
        };
    }
    return { mode: null, title: null };
}
/**
 * @function
 * Надо показать по какой логике управляется контур
 * @param control_modes - посчитанные значения
 * @return Возвращает режим управления и подсказку
 */
export function getConsumerControlConfig(control_modes) {
    const { is_dhw, has_pza, is_water, is_air, is_air_pid } = control_modes;
    if (is_dhw) {
        return { mode: 'water', title: 'Температура теплоносителя' };
    }
    if (has_pza) {
        if (is_air) {
            return { mode: 'air-pza', title: 'Управление по воздуху + ПЗА' };
        }
        if (is_air_pid) {
            return { mode: 'air-pid-pza', title: 'Управление по воздуху с ПИД + ПЗА' };
        }
        //чистый ПЗА == управление по ТН + ПЗА
        return { mode: 'pza', title: 'Управление по ПЗА' };
    }
    if (is_water) {
        return { mode: 'water', title: 'Управление по ТН' };
    }
    if (is_air) {
        return { mode: 'air', title: 'Управление по воздуху' };
    }
    if (is_air_pid) {
        return { mode: 'air-pid', title: 'Управление по воздуху с ПИД' };
    }
    return { mode: null, title: null };
}
export function mergeThermometer(config, state) {
    return {
        main: { ...config.main, ...state.main },
        reserve: { ...config.reserve, ...state.reserve },
    };
}
